import { type DropdownItem } from '@/forms-legacy'
import { dateUtils } from '@/utils'
import { getDay } from 'date-fns/esm'
import { type RecurrenceWhen } from '../../../../types'
import { createRecurrenceWhenId } from './createRecurrenceWhenId'

export function createMonthlyOptions(
  selectedDateYYYYMMDD: uui.domain.YYYYMMDD,
  formatRecurrenceWhenLabel: (recurrenceWhen: RecurrenceWhen) => string,
): DropdownItem[] {
  const selectedDate = dateUtils.parseDate(selectedDateYYYYMMDD)
  const cardinal = dateUtils.getWeekdayCardinality(selectedDate)

  const whenRecurrences: RecurrenceWhen[] = [
    {
      type: 'MONTHLY',
      date: selectedDateYYYYMMDD,
    },
    {
      type: 'MONTHLY',
      date: selectedDateYYYYMMDD,
      cardinal,
      weekday: getDay(selectedDate),
    },
  ]

  // Create array of objects with day index as key and day name as value
  return whenRecurrences.map<DropdownItem>(recurrenceWhen => {
    return {
      id: createRecurrenceWhenId(recurrenceWhen),
      label: formatRecurrenceWhenLabel(recurrenceWhen),
    }
  })
}
